import { getFeature } from "../../utils/features";

const useMultiDepthExperimentThreshold = () => {
  const { isEnabled, getVariables } = getFeature("pdp-review-multi-depth");
  const multiDepthThreshold = getVariables()?.threshold;

  if (!isEnabled()) {
    return { threshold: 3, showReviews: true };
  }

  let threshold = null;
  let showReviews = true;

  switch (multiDepthThreshold) {
    case "v1":
      threshold = 1;
      break;
    case "v5":
      threshold = 5;
      break;
    case "v0":
      showReviews = false;
      break;
    default:
      threshold = 3;
  }

  return { threshold, showReviews };
};

export default useMultiDepthExperimentThreshold;
